import React, {useState, useEffect} from 'react';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {Grid,} from '@material-ui/core/';
import ComponenteParaVisualizarOCargarDocumentoPDFFallecidos from 'components/CustomDialog';
import Title from 'components/TitleWithIcon';
import Form from 'components/Form/FormTwoColumns';
import { Close, CloudUpload } from '@material-ui/icons/';
import DialogLoadingMessage from 'components/LoadingMessage'
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import ApiServices from 'services/ApiServices';

function ComponenteParaVisualizarOCargarDocumentoPDF(props) {
    const classes = useStyles()
    const [elements, setElements] = useState({
                mostrarDocumentoPDF:{
                    idelement: "mostrarDocumentoPDF", label: "Visualizar documento", value:props.data.iddetalle, elementType:'showPDF', name:"mostrarPDF", controller:'captacionFallecidos',
                },
                cargarDocumentoPDF:{
                    idelement: "cargarDocumentoPDF", value: '', label: "Adjunte documento PDF *",
                    validators: {required: true,  size: "2 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'file',
                    disabled:false, name:"cargarDocumentoPDF", fileWidth: true, src: '', multiple: false, accept:".pdf", currentValue: ''
                },
            firmaElectronica:{ 
                idelement: "firmaElectronica", title:'Ingrese Firma Electrónica', position:"left", value: "", currentValue:"", isError:false, 
                validators: ['requireds'], elementType:'customTitle'
            },
                password: { 
                    idelement: "password",  value:'', label: 'Ingrese contraseña', pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", 
                    validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password', variant: 'outlined'
                },                
    })
    const [loadingMessage, setLoadingMessage] = useState({ loading: false, title: '' })

    const GuardarDocumentoPDF = async () => {
        // let saveData = {iddetalle: props.data.iddetalle, base64: elements.cargarDocumentoPDF.value}
        let saveData = {
            iddetalle: props.data.iddetalle, 
            base64: elements.cargarDocumentoPDF.value,
            firmaElectronica: elements.password.value
        }        
        setLoadingMessage({ loading: true, title: 'Cargando documento ... ' })

        try {
            let response = await ApiServices['captacionFallecidos'].subirDocumentoInvestigacion(saveData);
            if (response.error) {
                showMessagePersonalizedPosition('error', '¡Oopss!', response.error.message, 'center')
            } else {
                showMessagePersonalizedPosition('success', '¡BIEN! ', response.data, 'center')
                props.closeModal()
                props.actualizarTabla()
            }
        } catch (exception) {
            if (exception.status === 404) {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
        }
        setLoadingMessage({ loading: false, title: '' })        
    }

    const [buttonList] = React.useState({
        "functionSaveData": {
            "label": "guardar", "icon": <CloudUpload />, "callback": GuardarDocumentoPDF, "loading": false, "size": "medium",
            "background": "linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border": "0px", "borderRadius": "3", IsButtonCancelar:false,
            "boxShadow": "0 3px 5px 2px rgba(33, 203, 243, .3)", "color": "white", "height": 37, padding: "0 30px", disabled: false, isCancel: false, sendWithoutValidForm: true
        },
        "close": {
            "label": "Cerrar", "icon": <Close />, "callback": props.closeModal, "loading": false, "size": "medium", IsButtonCancelar: true,
            "background": "linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border": "0px", "borderRadius": "3",
            "boxShadow": "0 3px 5px 2px rgba(33, 203, 243, .3)", "color": "white", "height": 37, padding: "0 30px", disabled: false, isCancel: true, sendWithoutValidForm: true
        },
    });

    return (
        <ComponenteParaVisualizarOCargarDocumentoPDFFallecidos 
            titleToolbar={props.titleToolbar}
            iconToolbar={props.iconToolbar}
            open={props.open}
            fullScreen={props.fullScreen}
            closeModal={props.closeModal}
            actualizarTabla={props.actualizarTabla}
        >          
            <div id="scroller" className={classes.root}>
                <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title} />
                <div className={classes.colorComponente}>
                    <Grid container >
                        <Title title="Visualizar o Cargar Documento PDF" icon={"/menu/Document.png"}/>
                        <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center"> <br/>
                            <Form elements= {elements}  buttonList={buttonList} />
                        </Grid>                
                    </Grid><br/>
                    <div className={classes.lineaDegradadaBottom}></div>
                </div><br/>
            </div>
        </ComponenteParaVisualizarOCargarDocumentoPDFFallecidos>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(ComponenteParaVisualizarOCargarDocumentoPDF);